var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wcs-product-overlay-content",attrs:{"id":"panel_AfterPay"}},[_c('a',{attrs:{"href":_vm.afterpayUrl,"target":"_blank"}},[_c('img',{attrs:{"src":"https://static.secure-afterpay.com.au/modal-mobile.png"}})])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }